import { Moment } from 'moment';

export interface BukTicketQueryResponse<T> {
  result: string;
  total: number;
  group: BukTicketGroup;
  items: T[];
  issued_emails: string[];
  activated_emails: string[];
  error?: any;
}

export interface BukTicketQuery {
  limit: number;
  offset: number;
  order?: string;
  desc?: string; // '1'
  title?: string;
  issued_emails?: string[];
  activated_emails?: string[];
}

export interface BukTicketGroupListItem {
  id: number;
  name: string;
}

export interface BukTicketGroup {
  id: number;
  bid: string;
  expiryDate: string;
  name: string;
  period: string;
  sendDate: string;
  total: number;
  used: number;
  content_image_url: string;
  content_title: string;
}

export class BukTicketIssueData {
  method: 'email' | 'download';
  language: string;
  emailTitle: string;
  period?: '1w' | '2w' | '1m' | '3m' | '6m';
  expiryDate?: string | Moment;

  // 발송 정보 저장
  sender_name?: string;
  sender_email?: string;
  sender_logo_image_url?: string;
  save_sender?: boolean;

  // 이메일 발행
  email?: string; // , join
  message?: string;

  // 번호 발행
  count?: number;
}

export interface BukTicket {
  no: number;
  issued_at: string;
  expired_at: any;
  period: string;
}
export interface EmailBukTicket extends BukTicket {
  issued_to: string;
  activated_by: string;
  activated_at: string;
}
export interface LinkBukTicket extends BukTicket {
  issued_count: number;
  activated_count: number;
  activated_ratio: string;
  download_url: string;
}
export interface ImprintEmailBukTicket extends EmailBukTicket {
  content_id: string;
  content_title: string;
}

export interface ImprintLinkBukTicket extends LinkBukTicket {
  content_id: string;
  content_title: string;
}

export interface BukTicketContents {
  title: string;
  thumbnail?: string;
  author?: string;
}
export interface BukTicketSenderInfo {
  name: string;
  email?: string;
  logo_image_url?: string;
}
export interface BukTicketSenderInfo {
  name: string;
  email?: string;
  logo_image_url?: string;
}

export type BukTicketPublicationMethod = 'email' | 'link';

export type BukTicketContentsType = 'book' | 'service';

export const BukTicketDefaultLanguages = ['ko', 'en'];

export const BukTicketDefaultPeriods = ['1w', '2w', '1m', '3m', '6m', '1y'];

export const BukTicketDefaultExpiryDates = ['1m', '3m', '6m', '1y'];
